import { CLOUDFRONT_URL } from "../Config/config";

/**
 * Resolves a stored image path/key into a full URL.
 * If the path is already an absolute URL (starts with http), it's returned as is.
 * Otherwise, it's prefixed with the CloudFront domain.
 * 
 * @param {string} path - The image key or full URL
 * @returns {string} - The resolved full URL
 */
export const resolveImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) {
    return path;
  }
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${CLOUDFRONT_URL}/${cleanPath}`;
};
